module.exports = __webpack_public_path__ + "img/progress_045.3e713876.png";